import store from '../store'

export default async (to, from, next) => {
    if (store.getters['auth/check']) {

        if (from.name !=null && to.name != 'waiting' && store.getters['auth/user'].subscription_status == "152")
            next({name: 'waiting',query: from.query})

    }
    next();

}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js